import { render, staticRenderFns } from "./SummariesList.vue?vue&type=template&id=962c17b6"
import script from "./SummariesList.vue?vue&type=script&lang=js"
export * from "./SummariesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('962c17b6')) {
      api.createRecord('962c17b6', component.options)
    } else {
      api.reload('962c17b6', component.options)
    }
    module.hot.accept("./SummariesList.vue?vue&type=template&id=962c17b6", function () {
      api.rerender('962c17b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/summaries/views/SummariesList.vue"
export default component.exports